import React, { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { Helmet } from 'react-helmet-async';

import { getYachtsThunk, initialStateYacht } from '../../store/slices/catalogs/yacht.slice';
import { getScreenAdminThunk, initialStatePage } from '../../store/slices/pages/page.slice';

const Navbar = React.lazy(() => import('./components/Navbar'));
const OurHistory = React.lazy(() => import('./components/OurHistory'));
const ContactUs = React.lazy(() => import('../../components/contactus/ContactUs'));
const Footer = React.lazy(() => import('./components/Footer'));
import MainLoader from '../../components/Loaders/MainLoader';
import { scrollToTop } from '../../utils/funtions';

const OurHistoryPage = () => {

  const dispatch = useDispatch();
  const yachtState = useSelector(state => state.yachts);
  const ourHistoryState = useSelector(state => state.page);
  const isLoading = useSelector(state => state.isLoadingSlice);

  useEffect(() => {
    scrollToTop();
    dispatch(getScreenAdminThunk('our-history'));
    dispatch(getYachtsThunk())
    return () => {
      dispatch(initialStateYacht());
      dispatch(initialStatePage());
    }
  }, []);

  return (
    <div className='bg-white'>
      <Helmet>
        <title>About Us | Galapagos Cruise Experts Since 1982 – Rolf Wittmer</title>
        <meta name="description" content="Discover the story of Rolf Wittmer – pioneers of sustainable and first-class cruising in the Galapagos Islands for over 42 years." />
      </Helmet>
      {
        isLoading || yachtState.fetching || ourHistoryState.page?.sections === undefined ? <MainLoader /> :
          <>
            <Navbar yachtState={yachtState.yachts} />
            <OurHistory
              ourHistoryState={ourHistoryState.page}
            />
            <ContactUs />
            <Footer />
          </>
      }
    </div>
  );
};

export default OurHistoryPage;